import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { loginRequest } from '../lib/auth/config'

function MicrosoftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
      <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
      <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
    </svg>
  )
}

export default function Login() {
  const { instance, inProgress } = useMsal()

  // Guard against `interaction_in_progress`: only start a redirect when MSAL is
  // idle (it runs startup + handleRedirectPromise before settling to None), and
  // catch the promise so a failed/duplicate interaction isn't an unhandled rejection.
  const handleLogin = () => {
    if (inProgress !== InteractionStatus.None) return
    instance.loginRedirect(loginRequest).catch((e) => console.error('loginRedirect failed', e))
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span className="login-logo-text">ÄTA</span>
        </div>
        <h1 className="login-title">ÄTA Journal</h1>
        <p className="login-subtitle">Tibram – Ändringsorderhantering</p>
        <button
          className="login-btn"
          disabled={inProgress !== InteractionStatus.None}
          onClick={handleLogin}
        >
          <MicrosoftIcon />
          Logga in med Microsoft
        </button>
        <p className="login-hint">Använd ditt Tibram-konto</p>
      </div>
    </div>
  )
}
